// @flow
import { connect } from 'react-redux';
import { parse, stringify } from 'query-string';
import { assign, first } from 'lodash';
import { Forbidden } from 'http-errors';
import { authenticateUser } from '../modules/client';
import { login, getAndStoreUsers } from '../modules/actions';
import App from '../components/App';

function mapStateToProps(state: State) {
    return {
        user: state.user
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getLogin() {
            return authenticateUser().then(user => {
                dispatch(login(user));
                if (!user.clients || !user.clients.length) {
                    // No analytics companies resolved for this user: surface a
                    // clean "no access" screen instead of crashing on
                    // first(user.clients).clientId, which turns into an
                    // infinite redirectToLogin() loop.
                    throw new Forbidden('You do not have access to this app.');
                }
                if (
                    !parse(window.location.search).clientId ||
                    !user.clients.find(
                        client =>
                            client.id.toLowerCase() ==
                            parse(window.location.search).clientId.toLowerCase()
                    )
                ) {
                    window.location.search = stringify({ clientId: first(user.clients).clientId });
                }
                const clientId = parse(window.location.search).clientId;
                dispatch(getAndStoreUsers(clientId));

                return user;
            });
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./containers/AppContainer.jsx